export class PaginationEventData
{
    constructor(offset : number, increment : number)
    {
        this.offset = offset;
        this.increment = increment;
    }
    offset : number;
    increment : number;
}